import m2Sidebar from "@components/sidebar/m2_sidebar";
export default {
  components: {
    m2Sidebar: m2Sidebar
  },
  data() {
    var validateAddress = (rule, value, callback) => {
      if (this.ruleForm.permanent_address_country == null) {
        callback("请选择国家");
      } else {
        callback();
      }
    };
    var validateCity = (rule, value, callback) => {
      if (this.cityHave) {
        if (this.address.length !== 2) {
          callback("请选择城市");
        } else {
          callback();
        }
      } else callback();
    };
    var validatorGender = (rule, value, callback) => {
      if (this.ruleForm.gender == null) {
        callback("请选择性别");
      } else {
        callback();
      }
    };
    var validatorImage = (rule, value, callback) => {
      if (this.image_messagecode == "") {
        callback();
      } else {
        callback(getErrorMessage(this.image_messagecode));
      }
    };
    return {
      certGetInfoTimes: true,
      ruleForm: {
        avatar_link: "",
        birth_date: "",
        cert_id: "",
        cert_type: "",
        gender: 1,
        name: "",
        permanent_address_city: "",
        permanent_address_province: "",
        permanent_address_country: ""
      },
      ruleForm_rule: {
        image: [{ required: true, validator: validatorImage, trigger: "blur" }],
        name: [{ required: true, message: "请输入真实姓名", trigger: "blur" }],
        birth_date: [
          { required: true, message: "请选择出生日期", trigger: "blur" }
        ],
        gender: [
          { required: true, validator: validatorGender, trigger: "blur" }
        ],
        cert_type: [
          { required: true, message: "请选择一种种证件类型", trigger: "change" }
        ],
        //                    cert_id: [
        //                        {required: true, validator: validateCt, trigger: 'blur'}
        //                    ],
        country: [
          {
            required: true,
            validator: validateAddress,
            trigger: "change"
          }
        ],
        city: [{ required: true, validator: validateCity, trigger: "change" }]
      },
      image_messagecode: "",
      CertType: "",
      proc_id: null,
      file_guid: "",
      imageUrl: "",
      uploadUrl: "",
      cityHave: true,
      options: [{ children: [] }],
      certTypeNum: 0,
      btnDisable: false
    };
  },
  computed: {
    address: {
      get: function() {
        return [
          this.ruleForm.permanent_address_province,
          this.ruleForm.permanent_address_city
        ];
      },
      set: function(newValue) {
        this.ruleForm.permanent_address_province = newValue[0];
        this.ruleForm.permanent_address_city = newValue[1];
      }
    },
    exam_type: {
      get() {
        return this.$store.state.examInfo.currentExamInfo.exam_type;
      }
    },
    country: {
      get: function() {
        return this.ruleForm.permanent_address_country;
      },
      set: function(newValue) {
        if (!this.getStringSite(this.options, newValue)) {
          this.ruleForm.permanent_address_province = 0;
          this.ruleForm.permanent_address_city = 0;
          this.cityHave = false;
          this.$refs["city"].resetField();
        } else {
          this.cityHave = true;
        }
        this.ruleForm.permanent_address_country = newValue;
      }
    }
  },
  created: function() {
    this.$store.commit("setHeaderState", "0");
    this.getData();
  },
  methods: {
    getUseInfo: function() {
      this.$http.get(globalProvider.serviceUrl("pc/g")).then(data => {
        if (data.body.code == resultCode.Success) {
          this.ruleForm = data.body.data;
          this.$store.commit("setCurrentUser", data.body.data);
          let num = -1;
          this.options.forEach((item, index) => {
            if (item.value == this.ruleForm.permanent_address_country) {
              num = index;
            }
          });
          if (num == -1) {
            this.ruleForm.permanent_address_country = "";
            this.ruleForm.permanent_address_province = 0;
            this.ruleForm.permanent_address_city = 0;
            this.cityHave = false;
            this.$refs["city"].resetField();
          } else if (num == 1) {
            this.ruleForm.permanent_address_province = 0;
            this.ruleForm.permanent_address_city = 0;
            this.cityHave = false;
            this.$refs["city"].resetField();
          } else {
            this.cityHave = true;
          }
          this.getImg();
        }
      });
    },
    getData: function() {
      this.$http
        .get(globalProvider.serviceUrl("pc/g/ctn/{domain}"), {
          params: {
            domain: this.$store.state.examInfo.currentExamInfo.domain
          }
        })
        .then(data => {
          if (data.body.code == resultCode.Success) {
            this.CertType = data.body.data;
            this.getUseInfo();
          }
        });
    },
    getImg: function() {
      if (this.ruleForm.avatar_file_name != null) {
        this.$http
          .get(globalProvider.serviceUrl("oss/_f/g/lk/dl/{imgName}"), {
            params: {
              imgName: this.ruleForm.avatar_file_name
            }
          })
          .then(data => {
            if (data.body.code == resultCode.Success) {
              this.imageUrl = data.body.data[0].link;
              this.proc_id = data.body.data[0].proc_id;
              this.file_guid = data.body.data[0].file_guid;
            }
            if (data.body.code == resultCode.NotSuccess) {
              this.$alert(getErrorMessage(data.body.message), {
                confirmButtonText: "确定",
                callback: action => {}
              });
            }
          });
      }
    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    getStringSite: function(list, string) {
      let num = -1;
      if (list != [] && list != [{ children: [] }]) {
        list.forEach((item, index) => {
          if (item.value == string) {
            num = index;
          }
        });
      }
      if (num === 0) {
        return true;
      } else return false;
    },
    //图像上传
    upload: function(_upload) {
      this.$http
        .post(globalProvider.serviceUrl("oss/_f/g/lk/up/pc"), {
          proc_id: this.proc_id,
          file_guid: this.file_guid,
          file_name: _upload.file.name,
          type: _upload.file.type
        })
        .then(data => {
          if (data.body.code == resultCode.Success) {
            this.uploadUrl = data.body.data.link;
            this.proc_id = data.body.data.proc_id;
            this.file_guid = data.body.data.file_guid;
            this.$http
              .put(this.uploadUrl, _upload.file, {
                headers: {
                  "Content-Type": _upload.file.type,
                  "Content-Disposition":
                    "attachment;filename=" + encodeURI(_upload.file.name)
                }
              })
              .then(response => {
                if (response.status == 200) {
                  this.$http
                    .get(
                      globalProvider.serviceUrl("oss/_f/g/lk/dl/{proc_id}"),
                      {
                        params: { proc_id: this.proc_id }
                      }
                    )
                    .then(data => {
                      if (data.body.code == resultCode.Success) {
                        this.imageUrl = data.body.data[0].link;
                      } else if (data.body.code == resultCode.NotSuccess) {
                        this.image_messagecode = data.body.message;
                        this.$refs.ruleForm.validateField("image");
                      }
                    });
                }
              });
          }
        });
    },
    //上传前验证图像
    beforeAvatarUpload(file) {
      const isJPG = file.type == "image/jpeg" || file.type == "image/png";
      const isLt1M = file.size / 1024 / 1024 <= 1;
      if (!isJPG) {
        this.$alert("证件照仅支持jpg、png格式，请上传格式正确图片", {
          confirmButtonText: "确定"
        });
        return false;
      }
      if (!isLt1M) {
        this.$alert("证件照过大，请上传1M以内的图片", {
          confirmButtonText: "确定"
        });
        return false;
      }
      return true;
    },
    //更新个人信息
    saveUserInform(formName) {
      this.btnDisable = true;
      this.image_messagecode = "";
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$http
            .post(globalProvider.serviceUrl("pc/u"), {
              afn: this.proc_id,
              gd: this.ruleForm.gender,
              bd: this.ruleForm.birth_date
            })
            .then(data => {
              this.btnDisable = false;
              if (data.body.code == resultCode.Success) {
                this.getUseInfo();
                this.$alert("恭喜你，保存成功！", {
                  confirmButtonText: "确定"
                });
              } else if (data.body.code == resultCode.NotSuccess) {
                this.$alert(getErrorMessage(data.body.message), {
                  confirmButtonText: "确定",
                  callback: action => {}
                });
              }
            });
        } else {
          this.btnDisable = false;
          return false;
        }
      });
    }
  }
};